// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8811b55e","239":"a55b8408","455":"6736dd57"}[chunkId] + ".chunk.js";
};